import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import {
  AGENT_AUTHENTICATION_ERROR_CODE,
  TOKEN_TIMEOUT_ERROR_CODE,
} from '@constants/app.constants';
import { ApiError } from '@models/app.models';
import { AppApiErrorsCopy } from '@models/cms/app-api-errors.model';
import { BBoxService } from '@services/bbox/bbox.service';
import { GrowthBookService } from '@services/growthbook/growthbook.service';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalType } from '@models/app.models';
import posthog from 'posthog-js';
import { ErrorHandlerGenericService } from '@services/error-handler-generic/error-handler-generic.service';

@Component({
  selector: 'app-api-error-list-modal',
  standalone: true,
  imports: [CommonModule, AlertModule],
  templateUrl: './api-error-list-modal.component.html',
  styleUrls: ['./api-error-list-modal.component.scss'],
})
export class ApiErrorListModalComponent implements OnInit {

  public errorHandlerGenericService = inject(ErrorHandlerGenericService);

  @Input() errors: ApiError[] = [];

  cmsApiErrorCopy: AppApiErrorsCopy;

  readonly TOKEN_TIMEOUT_ERROR_CODE = TOKEN_TIMEOUT_ERROR_CODE as string;
  readonly AGENT_AUTHENTICATION_ERROR_CODE =
    AGENT_AUTHENTICATION_ERROR_CODE as string;

  constructor(
    public bsModalRef: BsModalRef,
    public gbs: GrowthBookService,
    private bboxService: BBoxService,
  ) {
    posthog.captureException('error_modal_shown', {
      level: 'error',
      tags: { ['tab-active']: !document.hidden },
      extra: { errors: JSON.stringify(this.errors) },
    });
  }

  ngOnInit(): void {
    if (this.errors.length > 0) {
      this.errors.map((error) => {
        this.trackModal(error);
      });
    }
  }

  private trackModal(error: ApiError): void {
    this.bboxService.trackModal({
      type: ModalType.API_ERROR,
      code: error.code ?? '',
      message: error.message ?? '',
    });
  }
 
}
